export const WEBSITE_ENV = 'prod';
